import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./search-group-info-plams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./search-group-info-plams.component.scss?ngResource";
import { Component, Input } from "@angular/core";
import { ApplicationSearchConstants } from "../../../application-search-constants";
import { FormControl, FormGroup } from "@angular/forms";
import { ApplicationSearchService } from "../../../../shared/application-search.service";
import { AflaModuleStrategyService } from "../../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../../app-controller.service";
let SearchGroupInfoPlamsComponent = class SearchGroupInfoPlamsComponent {
    applicationSearchService;
    aflaModuleStrategyService;
    appController;
    groupName;
    groupInfoNameLabel = ApplicationSearchConstants.FORM_CONTROLS.nameLabel;
    groupInfoSurnameLabel = ApplicationSearchConstants.FORM_CONTROLS.surnameLabel;
    groupInfoOrganisationLabel = ApplicationSearchConstants.FORM_CONTROLS.organisationLabel;
    groupInfoNameFormControl = ApplicationSearchConstants.FORM_CONTROLS.nameFormControl;
    groupInfoSurnameFormControl = ApplicationSearchConstants.FORM_CONTROLS.surnameFormControl;
    groupInfoOrganisationFormControl = ApplicationSearchConstants.FORM_CONTROLS.organisationFormControl;
    searchText = ApplicationSearchConstants.FORM_CONTROLS.searchText;
    groupInfoForm;
    applicationSearchCallback;
    constructor(applicationSearchService, aflaModuleStrategyService, appController) {
        this.applicationSearchService = applicationSearchService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
    }
    ngOnInit() {
        this.setUpForm();
    }
    searchApplication($event) {
        const name = this.groupInfoForm.get(this.groupInfoNameFormControl).value;
        const surname = this.groupInfoForm.get(this.groupInfoSurnameFormControl).value;
        const organisation = this.groupInfoForm.get(this.groupInfoOrganisationFormControl).value;
        this.applicationSearchCallback(this.applicationSearchService.searchByGroupInfo(name, surname, organisation, this.groupName, this.aflaModuleStrategyService, Number(this.appController.selectedModuleID)));
    }
    setUpForm() {
        this.groupInfoForm = new FormGroup({
            nameFormControl: new FormControl(""),
            surnameFormControl: new FormControl(""),
            organisationFormControl: new FormControl("")
        });
    }
    static ctorParameters = () => [
        { type: ApplicationSearchService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService }
    ];
    static propDecorators = {
        groupName: [{ type: Input }]
    };
};
SearchGroupInfoPlamsComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-search-group-info-plams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], SearchGroupInfoPlamsComponent);
export { SearchGroupInfoPlamsComponent };
